<template>
  <div :class="$style['pt-old-to-new']">
      <pt-page-title title="脐荐康管理" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey" @searchNo="searchNo"></pt-page-title>
      <pt-page-menu-filter :tabs="oldToNewTabs" v-model="selectTab"></pt-page-menu-filter>
      <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="filter">
          <el-button type="primary" @click="filter()">筛选</el-button>
          <el-button type="primary" @click="exportOldToNew" :loading="exportLoading">导出</el-button>
          <el-button type="primary" @click="exportHistoryOldToNew">导出历史</el-button>
          <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </pt-page-factor-filter>
      <div :class="$style['batch-button']">
          <el-button type="primary" @click="batchGrant">批量发放</el-button>
     </div>
     <pt-old-to-new-table :tableLabels="tableLabels" v-if="istTableShow" :queryParams="paramsData" @select="select"
     @selectAll="selectAll" :isFromRouter="isFromRouter" :selectTab="selectTab" ref="table">
        <template >
            <template v-if="selectTab === 'OLD'||selectTab === 'NEW'">
                <el-table-column label="发放状态">
                    <template slot-scope="scope">
                        <div :class="((selectTab === 'OLD'&&isRejectRowOld(scope.row))||(selectTab==='NEW'&&isRejectRowNew(scope.row)))?$style['reject-state']:''">
                        {{selectTab === 'OLD'?(scope.row.oldCustomer&&scope.row.oldCustomer.reward_status):(scope.row.newCustomer&&scope.row.newCustomer.reward_status)}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="发放时间">
                    <template slot-scope="scope">
                        {{selectTab === 'OLD'?(scope.row.oldCustomer&&scope.row.oldCustomer.reward_date):(scope.row.newCustomer&&scope.row.newCustomer.reward_date)}}
                    </template>
                </el-table-column>
            </template>
         <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
             <el-button type="text" @click="getDetail(scope.row)">{{isShowGrantButton(scope.row)?'发放':'详情'}}</el-button>
            </template>
         </el-table-column>
         </template>
     </pt-old-to-new-table>
  </div>
</template>

<script>
// 组件class前缀
import { oldToNewTabs, filterLabels, oldToNewTableLabels, oldTableLabels, newTableLabels, newFilterLabels, oldFilterLabels } from './old-to-new.js'
import ptOldToNewTable from './pt-old-to-new-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
const prefixCls = 'pt-old-to-new'
export default {
  name: 'pt-old-to-new',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableLabels () {
      return this.selectTab === 'ALL' ? oldToNewTableLabels : (this.selectTab === 'OLD' ? oldTableLabels : newTableLabels)
    },
    filterLabels () {
      return this.selectTab === 'ALL' ? filterLabels : (this.selectTab === 'OLD' ? oldFilterLabels : newFilterLabels)
    },
    tableData () {
      return this.$refs.table.tableData
    }
  },
  props: {
    exportLoading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ptOldToNewTable
  },
  data () {
    return {
      oldToNewTabs: oldToNewTabs,
      selectTab: 'ALL',
      params: {},
      paramsData: {},
      isQueryRouter: true,
      isFromRouter: false,
      istTableShow: true,
      recordMessage: 0,
      searchKey: null
    }
  },
  watch: {
    selectTab (val) {
      for (var key in this.paramsData) {
        this.$delete(this.paramsData, key)
      }
      this.paramsData.type = val
      this.reload()
    }
  },
  methods: {
    isShowGrantButton (row) {
      return (this.selectTab === 'ALL' && ((row.newCustomer.rewardStatus === 'NO_REWARD' && row.recordUserType !== 'OLD') || row.oldCustomer.rewardStatus === 'NO_REWARD')) ||
      (this.selectTab === 'OLD' && row.oldCustomer.rewardStatus === 'NO_REWARD') || (this.selectTab === 'NEW' && row.newCustomer.rewardStatus === 'NO_REWARD')
    },
    searchNo (val) {
      this.searchKey = val
      emptyObject(this.params)
    },
    search (val) {
      this.isFromRouter = false
      this.searchKey = val
      emptyObject(this.params)
      emptyObject(this.paramsData)
      this.paramsData.searchKey = val
    },
    emptySearch () {
      this.$delete(this.paramsData, 'searchKey')
    },
    // 判断当前记录的状态是否是已驳回
    isRejectRowOld (row) {
      let rewardStatus = row.oldCustomer.rewardStatus
      if (rewardStatus === 'SALES_REJECTED' || rewardStatus === 'REJECTED') {
        return true
      } else {
        return false
      }
    },
    isRejectRowNew (row) {
      let rewardStatus = row.newCustomer.rewardStatus
      if (rewardStatus === 'SALES_REJECTED' || rewardStatus === 'REJECTED') {
        return true
      } else {
        return false
      }
    },
    exportOldToNew () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          let params = { ...this.params }
          for (var key in this.params) {
            if (key === 'achieveDate') {
              params = { ...this.params.achieveDate, ...this.params }
              this.$delete(params, 'achieveDate')
              this.$delete(params, 'index')
            }
            if (key === 'oldBind') {
              params.oldBind = params.oldBind === 'true'
            }
            this.$delete(params, 'state')
          }
          for (let key1 in params) {
            if (!params[key1]) {
              this.$delete(params, key1)
            }
          }
          this.$emit('exportOldToNew', params)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportHistoryOldToNew () {
      this.$router.push('/export-history/old_to_new/?name=customer_bring_new_export')
    },
    selectAll (rows) {
      this.recordMessage = rows
    },
    select (row) {
      this.recordMessage = row
    },
    getDetail (row) {
      let tab = this.selectTab
      // 如果是全部选项卡，且点了老用户那条记录，详情界面应只显示老用户
      if (tab === 'ALL') {
        tab = row.recordUserType
      }
      this.$router.push('/old-to-new/old-to-new-detail/' + row.id + '/' + tab)
    },
    batchGrant () {
      if (this.recordMessage.length) {
        this.$emit('bringNewStatistice', this.recordMessage, this.selectTab)
      } else {
        this.$alert('您尚未选择脐荐康用户进行批量发放,请选择脐荐康记录', '批量发放提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
      }
    },
    filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (key === 'achieveDate') {
          this.paramsData = { ...this.params.achieveDate, ...this.params }
          this.$delete(this.paramsData, 'achieveDate')
          this.$delete(this.paramsData, 'index')
        }
        if (key === 'oldBind') {
          this.paramsData.oldBind = this.paramsData.oldBind === 'true'
        }
        this.$delete(this.paramsData, 'state')
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.params)
      }
      this.paramsData = { ...this.params, ...this.paramsData }
      for (let key1 in this.paramsData) {
        if (!this.paramsData[key1]) {
          this.$delete(this.paramsData, key1)
        }
      }
    },
    cleanParams () {
      emptyObject(this.paramsData)
      emptyObject(this.params)
      this.Filter()
    },
    reload () {
      this.istTableShow = false
      this.$nextTick(_ => {
        this.istTableShow = true
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.batch-button{
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}
.pt-old-to-new{
    :global
    .page-factor-filter-top{
        margin-bottom: 0
    }
}
.reject-state{
    color: red
}
</style>
